module.exports = __webpack_public_path__ + "/hashedassets-launcher/v2/tfl_conversation_invite.b570819a000798f3a82e86bac2c75431.svg";